/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import config from "config";
import { SECTION_MAP } from "modules/candidate/profile/constants/sectionConstants";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import Image from "next/image";
import React, { useEffect } from "react";

const UpdateProfileCard = ({ userData }) => {
	const profileDetails = userData?.[SECTION_MAP.OVERALL]?.profileCardDetails;
	const experienceDetails =
		(Array.isArray(
			userData?.[SECTION_MAP.PROFESSIONAL_DETAILS]?.Experience?.experiences
		) &&
			userData?.[SECTION_MAP.PROFESSIONAL_DETAILS]?.Experience?.experiences
				?.length > 0 &&
			userData?.[SECTION_MAP.PROFESSIONAL_DETAILS]?.Experience?.experiences[0]) ||
		{};
	// const educationDetails = userData?.[SECTION_MAP.PROFESSIONAL_DETAILS]?.Education;

	const renderTitle = () => {
		if (experienceDetails?.jobTitle) return experienceDetails?.jobTitle;
		return null;
	};
	const renderSubtitle = () => {
		if (experienceDetails?.companyName) return experienceDetails?.companyName;
		return null;
	};
	const handleUpdateProfile = () => {
		trackOnMixpanel("Update profile clicked web", {
			source: "Job Feed Web",
		});
		window.open("/profile", "_self");
	};
	const imageURL = profileDetails?.photoURL
		? `${config.gumletBaseUrl}/${profileDetails?.photoURL}`
		: "https://cdn.apna.co/cloudinary/job_detail_page_images/defaultUserImg.jpg";

	useEffect(() => {
		trackOnMixpanel("Update profile shown web", {
			source: "Job Feed Web",
		});
	}, []);
	return (
		<div className="m-3 flex items-start gap-[12px] rounded-xl border border-solid bg-white p-[12px] md:m-0 md:flex-col md:items-center md:p-[16px]">
			<div className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-solid md:h-16 md:w-16">
				<Image src={imageURL} alt="" layout="fill" className="object-cover" />
			</div>
			<div className="flex-1 md:text-center">
				<p className="m-0 max-w-[220px] truncate text-ellipsis text-md font-semibold leading-[24px]">
					{profileDetails?.name}
				</p>
				<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
					{renderTitle()}
				</p>
				<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
					{renderSubtitle()}
				</p>
			</div>
			<div
				className="cursor-pointer rounded border border-solid border-[#1F8268] px-[8px] py-[4px] text-center text-xs font-semibold leading-[16px] text-[#1F8268] md:w-full"
				onClick={handleUpdateProfile}
			>
				Update <span className="hidden md:inline-block">profile</span>
			</div>
		</div>
	);
};

export default UpdateProfileCard;
